// Carrier constants
export const CARRIERS = {
  CMA_CGM: 'CMA_CGM',
  MAERSK: 'MAERSK', 
  MSC: 'MSC',
  PORT_AUTHORITY: 'PORT_AUTHORITY',
  CUSTOMS: 'CUSTOMS',
  OTHER: 'OTHER'
};

export const CARRIER_NAMES = {
  [CARRIERS.CMA_CGM]: 'CMA CGM',
  [CARRIERS.MAERSK]: 'Maersk',
  [CARRIERS.MSC]: 'MSC',
  [CARRIERS.PORT_AUTHORITY]: 'Port Authority',
  [CARRIERS.CUSTOMS]: 'Customs',
  [CARRIERS.OTHER]: 'Other Carrier'
};

// Container status constants
export const CONTAINER_STATUS = {
  BOOKED: 'BOOKED',
  CGI: 'CGI',
  CLL: 'CLL',
  IN_TRANSIT: 'IN_TRANSIT',
  CDD: 'CDD',
  CGO: 'CGO',
  READY_FOR_PICKUP: 'READY_FOR_PICKUP',
  CUSTOMS_CLEARED: 'CUSTOMS_CLEARED',
  CUSTOMS_PENDING: 'CUSTOMS_PENDING',
  CUSTOMS_EXAM: 'CUSTOMS_EXAM',
  CLL_TS: 'CLL_TS',
  VAD: 'VAD',
  VDL: 'VDL',
  FRT_AVAILABLE: 'FRT_AVAILABLE',
  EPU: 'EPU',
  X_CLEARED: 'X_CLEARED',
  I_CLEARED: 'I_CLEARED',
  DELIVERED: 'DELIVERED'
};

export const STATUS_DISPLAY_NAMES = {
  [CONTAINER_STATUS.BOOKED]: 'Bookings',
  [CONTAINER_STATUS.CGI]: 'Gate-In at Origin Port - Container accepted by terminal',
  [CONTAINER_STATUS.CLL]: 'Container Loaded - On board scheduled vessel',
  [CONTAINER_STATUS.IN_TRANSIT]: 'In Transit',
  [CONTAINER_STATUS.CDD]: 'Container Discharged at Destination Port',
  [CONTAINER_STATUS.CGO]: 'Gate-Out from Port - On truck for final delivery',
  [CONTAINER_STATUS.READY_FOR_PICKUP]: 'Ready for Pickup',
  [CONTAINER_STATUS.CUSTOMS_CLEARED]: 'Customs clearance completed',
  [CONTAINER_STATUS.CUSTOMS_PENDING]: 'Awaiting customs clearance',
  [CONTAINER_STATUS.CUSTOMS_EXAM]: 'Customs examination required',
  [CONTAINER_STATUS.CLL_TS]: 'Re-Loaded on Vessel - Next voyage leg',
  [CONTAINER_STATUS.VAD]: 'Vessel Arrived at Destination Port',
  [CONTAINER_STATUS.VDL]: 'Vessel Departed - Voyage begun',
  [CONTAINER_STATUS.FRT_AVAILABLE]: 'Ready for Pickup',
  [CONTAINER_STATUS.EPU]: 'Empty Container Picked Up - Collected from depot',
  [CONTAINER_STATUS.X_CLEARED]: 'Customs Cleared (Export) - Approved for export',
  [CONTAINER_STATUS.I_CLEARED]: 'Customs Cleared (Import) - Released to consignee',
  [CONTAINER_STATUS.DELIVERED]: 'Delivered'
};

// Milestone types
export const MILESTONE_TYPES = {
  GATE_IN: 'GATE_IN',
  LOADED: 'LOADED', 
  IN_TRANSIT: 'IN_TRANSIT',
  DISCHARGED: 'DISCHARGED',
  READY_FOR_PICKUP: 'READY_FOR_PICKUP'
};

export const MILESTONE_DISPLAY_NAMES = {
  [MILESTONE_TYPES.GATE_IN]: 'Gate In at Terminal',
  [MILESTONE_TYPES.LOADED]: 'Loaded on Vessel',
  [MILESTONE_TYPES.IN_TRANSIT]: 'Vessel Departed',
  [MILESTONE_TYPES.DISCHARGED]: 'Discharged at Destination',
  [MILESTONE_TYPES.READY_FOR_PICKUP]: 'Ready for Pickup'
};

// Agent roles
export const AGENT_ROLES = {
  AGENT: 'AGENT',
  SUPERVISOR: 'SUPERVISOR',
  ADMIN: 'ADMIN'
};

export const ROLE_DISPLAY_NAMES = {
  [AGENT_ROLES.AGENT]: 'Agent',
  [AGENT_ROLES.SUPERVISOR]: 'Supervisor',
  [AGENT_ROLES.ADMIN]: 'Administrator'
};